import React, { useContext, useEffect, useState } from 'react';
import $ from 'jquery';
import { v4 as uuid } from 'uuid';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import {
  Box,
  Button,
  Divider,
  InputAdornment,
  Stack,
  TextField
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { MdAdd, MdRemove } from 'react-icons/md';
import Toast from '../../../../components/Toast';
import { useIntegration } from '../../../../hooks/Integration';
import { useModal } from '../../../../hooks/Modal';
import { options } from '../../../../helpers/toastOptions';
import { parseCpfCnpj } from '../../../../helpers/parseValues';
import { DefaultCollectContext } from '../..';
import { ModalTitle } from './styled';

export const ModalCreateDeclaration = () => {
  const [senderDocument, setSenderDocument] = useState('');
  const [senderZipPostalCode, setSenderZipPostalCode] = useState('');
  // const [senderZipSearchedByDocument, setSenderZipSearchedByDocument] =
  //   useState('');
  const [recipientDocument, setRecipientDocument] = useState('');
  const [recipientName, setRecipientName] = useState('');
  const [recipientZipPostalCode, setRecipientZipPostalCode] = useState('');
  const [recipientStreetAddress, setRecipientStreetAddress] = useState('');
  const [recipientStreetAddressNumber, setRecipientStreetAddressNumber] =
    useState('');
  // const [recipientZipSearchedByDocument, setRecipientZipSearchedByDocument] =
  //   useState('');
  const [recipientAdditionalInformation, setRecipientAdditionalInformation] =
    useState('');
  const [recipientSuburb, setRecipientSuburb] = useState('');
  const [recipientCity, setRecipientCity] = useState('');
  const [recipientState, setRecipientState] = useState('');
  const [disableSenderName, setDisableSenderName] = useState(false);
  const [disableSenderStreetAddress, setDisableSenderStreetAddress] =
    useState(true);
  const [disableSenderSuburb, setDisableSenderSuburb] = useState(true);
  const [disableRecipientName, setDisableRecipientName] = useState(false);
  const [disableRecipientStreetAddress, setDisableRecipientStreetAddress] =
    useState(true);
  const [disableRecipientSuburb, setDisableRecipientSuburb] = useState(true);
  const [isToValidateRecipientDocument, setIsToValidateRecipientDocument] =
    useState(false);
  const [commodityList, setCommodityList] = useState([
    {
      id: uuid(),
      description: '',
      quantity: '',
      weight: '',
      unityValue: '',
      totalValue: '',
      observation: ''
    }
  ]);
  const [hasMissingAddressValue, setHasMissingAddressValue] = useState(true);
  const [hasMissingCommodityValue, setHasMissingCommodityValue] =
    useState(true);

  const { searchUser, getAddressByZipPostalCode } = useIntegration();
  const { Modal, closeModal } = useModal();

  const maxSM = useMediaQuery('(max-width:768px)');
  const maxMD = useMediaQuery('(max-width:900px)');

  const {
    collectSenderData,
    collectRecipientData,
    collectLoadData,
    materialTypeList,
    createDeclarationPdf,
    fileAmount,
    declarationFiles,
    openCreateDeclarationModal
  } = useContext(DefaultCollectContext);

  const createDeclarationSchema = Yup.object().shape({
    senderDocument: Yup.string()
      .required('CNPJ/CPF obrigatório')
      .trim('CNPJ/CPF obrigatório'),
    senderName: Yup.string()
      .required('Razão Social / Nome obrigatório')
      .trim('Razão Social / Nome obrigatório'),
    senderZipPostalCode: Yup.string()
      .required('CEP obrigatório')
      .trim('CEP obrigatório')
      .test('validateZipPostalCode', 'CEP inválido', (value) => {
        const regex = /^\d{8}$/;
        return value.replace('-', '').match(regex);
      }),
    senderStreetAddress: Yup.string()
      .required('Endereço obrigatório')
      .trim('Endereço obrigatório'),
    senderStreetAddressNumber: Yup.string()
      .required('Número obrigatório')
      .trim('Número obrigatório')
      .test('validateStreetAddressNumber', 'Número inválido', (value) => {
        return value && parseInt(value.replace(/[A-Za-z\s]/, ''), 10) > 0;
      }),
    senderAdditionalInformation: Yup.string(),
    senderSuburb: Yup.string()
      .required('Bairro obrigatório')
      .trim('Bairro obrigatório'),
    senderCity: Yup.string()
      .required('Cidade obrigatória')
      .trim('Cidade obrigatória'),
    senderState: Yup.string()
      .required('Estado obrigatório')
      .trim('Estado obrigatório'),
    recipientDocument: Yup.string()
      .required('CNPJ/CPF obrigatório')
      .trim('CNPJ/CPF obrigatório')
      .test('validadeDocument', 'CNPJ/CPF inválido', (value) => {
        if (isToValidateRecipientDocument) {
          return (
            typeof value === 'string' &&
            [11, 14].includes(parseCpfCnpj(value)?.length)
          );
        }

        return true;
      }),
    recipientName: Yup.string()
      .required('Razão Social / Nome obrigatório')
      .trim('Razão Social / Nome obrigatório'),
    recipientZipPostalCode: Yup.string()
      .required('CEP obrigatório')
      .trim('CEP obrigatório')
      .test('validateZipPostalCode', 'CEP inválido', (value) => {
        const regex = /^\d{8}$/;
        return value.replace('-', '').match(regex);
      }),
    recipientStreetAddress: Yup.string()
      .required('Endereço obrigatório')
      .trim('Endereço obrigatório'),
    recipientStreetAddressNumber: Yup.string()
      .required('Número obrigatório')
      .trim('Número obrigatório'),
    recipientAdditionalInformation: Yup.string(),
    recipientSuburb: Yup.string()
      .required('Bairro obrigatório')
      .trim('Bairro obrigatório'),
    recipientCity: Yup.string()
      .required('Cidade obrigatória')
      .trim('Cidade obrigatória'),
    recipientState: Yup.string()
      .required('Estado obrigatório')
      .trim('Estado obrigatório')
  });

  const {
    handleSubmit,
    control,
    setValue,
    clearErrors,
    watch,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(createDeclarationSchema),
    mode: 'onBlur',
    reValidateMode: 'onChange'
  });

  const onSubmit = (data) => {
    const {
      // eslint-disable-next-line no-shadow
      senderDocument,
      senderName,
      // eslint-disable-next-line no-shadow
      senderZipPostalCode,
      senderStreetAddress,
      senderStreetAddressNumber,
      senderAdditionalInformation,
      senderSuburb,
      senderCity,
      senderState,
      // eslint-disable-next-line no-shadow
      recipientDocument,
      // eslint-disable-next-line no-shadow
      recipientName,
      // eslint-disable-next-line no-shadow
      recipientZipPostalCode,
      // eslint-disable-next-line no-shadow
      recipientStreetAddress,
      // eslint-disable-next-line no-shadow
      recipientStreetAddressNumber,
      // eslint-disable-next-line no-shadow
      recipientAdditionalInformation,
      // eslint-disable-next-line no-shadow
      recipientSuburb,
      // eslint-disable-next-line no-shadow
      recipientCity,
      // eslint-disable-next-line no-shadow
      recipientState
    } = data;

    const senderData = {
      document: senderDocument,
      name: senderName,
      address: {
        zipPostalCode: senderZipPostalCode,
        streetAddress: senderStreetAddress,
        streetAddressNumber: senderStreetAddressNumber,
        additionalInformation: senderAdditionalInformation,
        suburb: senderSuburb,
        city: senderCity,
        state: senderState
      }
    };

    const recipientData = {
      document: recipientDocument,
      name: recipientName,
      address: {
        zipPostalCode: recipientZipPostalCode,
        streetAddress: recipientStreetAddress,
        streetAddressNumber: recipientStreetAddressNumber,
        additionalInformation: recipientAdditionalInformation,
        suburb: recipientSuburb,
        city: recipientCity,
        state: recipientState
      }
    };

    // let hasDescriptionError = false;
    let hasQuantityError = false;
    let hasWeightError = false;
    let hasUnityValueError = false;

    const newCommodityList = [...commodityList];

    commodityList?.forEach((value, index) => {
      // if (!value.description) {
      //   newCommodityList[index].hasDescriptionError = true;
      //   hasDescriptionError = true;
      // }

      if (!value.quantity || value.quantity <= 0) {
        newCommodityList[index].hasQuantityError = true;
        hasQuantityError = true;
      }

      if (
        !value.weight ||
        Number(value.weight.replaceAll('.', '').replace(',', '.')) <= 0
      ) {
        newCommodityList[index].hasWeightError = true;
        hasWeightError = true;
      }

      if (
        !value.unityValue ||
        Number(value.unityValue.replaceAll('.', '').replace(',', '.')) <= 0
      ) {
        newCommodityList[index].hasUnityValueError = true;
        hasUnityValueError = true;
      }
    });

    if (
      // hasDescriptionError ||
      hasQuantityError ||
      hasWeightError ||
      hasUnityValueError
    ) {
      setCommodityList(newCommodityList);

      return;
    }

    createDeclarationPdf({ senderData, recipientData, commodityList });

    closeModal();

    if (declarationFiles.length + 1 < fileAmount) {
      openCreateDeclarationModal();
    }

    toast(
      <Toast
        title=""
        content={`${declarationFiles.length + 1}ª declaração preenchida`}
        type="info"
      />,
      options
    );
  };

  const getDocumentInfo = async (value, entity) => {
    entity === 'recipient' && setIsToValidateRecipientDocument(true);

    if (value) {
      try {
        const response = await searchUser({
          searchData: { document: parseCpfCnpj(value) }
        });
        if (response?.length > 0) {
          const userSearched = response[0];

          if (userSearched?.document) {
            const {
              name,
              zipPostalCode,
              streetAddress,
              streetAddressNumber,
              addressComplement,
              suburb,
              city,
              state
            } = userSearched;

            setValue(`${entity}Name`, name.toUpperCase());
            setValue(`${entity}ZipPostalCode`, zipPostalCode);
            setValue(`${entity}StreetAddress`, streetAddress.toUpperCase());
            streetAddressNumber
              ? setValue(`${entity}StreetAddressNumber`, streetAddressNumber)
              : setValue(`${entity}StreetAddressNumber`, '');
            addressComplement
              ? setValue(`${entity}AdditionalInformation`, addressComplement)
              : setValue(`${entity}AdditionalInformation`, '');
            setValue(`${entity}Suburb`, suburb.toUpperCase());
            setValue(`${entity}City`, city.toUpperCase());
            setValue(`${entity}State`, state.toUpperCase());

            clearErrors([
              `${entity}Document`,
              `${entity}Name`,
              `${entity}ZipPostalCode`,
              `${entity}StreetAddress`,
              `${entity}StreetAddressNumber`,
              `${entity}AdditionalInformation`,
              `${entity}Suburb`,
              `${entity}City`,
              `${entity}State`
            ]);

            if (entity === 'sender') {
              setSenderZipPostalCode(zipPostalCode);
              // setSenderZipSearchedByDocument(zipPostalCode);
              setDisableSenderName(true);
              setDisableSenderStreetAddress(true);
              setDisableSenderSuburb(true);
            } else {
              setRecipientName(name.toUpperCase());
              setRecipientZipPostalCode(zipPostalCode);
              // setRecipientZipSearchedByDocument(zipPostalCode);
              setRecipientStreetAddress(streetAddress.toUpperCase());
              streetAddressNumber
                ? setRecipientStreetAddressNumber(streetAddressNumber)
                : setRecipientStreetAddressNumber('');
              addressComplement
                ? setRecipientAdditionalInformation(addressComplement)
                : setRecipientAdditionalInformation('');
              setRecipientSuburb(suburb.toUpperCase());
              setRecipientCity(city.toUpperCase());
              setRecipientState(state.toUpperCase());
              setDisableRecipientName(true);
              setDisableRecipientStreetAddress(true);
              setDisableRecipientSuburb(true);
              setIsToValidateRecipientDocument(false);
            }
          }
        } else {
          if (entity === 'sender') {
            setDisableSenderName(false);
          } else {
            setDisableRecipientName(false);
          }

          toast(
            <Toast
              title="Atenção!"
              content="Usuário não foi localizado com o documento informado."
              type="error"
            />,
            options
          );
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    } else if (entity === 'sender') {
      setDisableSenderName(false);
      setValue('senderName', '');

      if (!senderZipPostalCode) {
        setValue('senderStreetAddress', '');
        setValue('senderStreetAddressNumber', '');
        setValue('senderAdditionalInformation', '');
        setValue('senderSuburb', '');
        setValue('senderCity', '');
        setValue('senderState', '');
      }
    } else {
      setDisableRecipientName(false);
      setValue('recipientName', '');
      setRecipientName('');

      if (!recipientZipPostalCode) {
        setValue('recipientStreetAddress', '');
        setRecipientStreetAddress('');
        setValue('recipientStreetAddressNumber', '');
        setRecipientStreetAddressNumber('');
        setValue('recipientAdditionalInformation', '');
        setRecipientAdditionalInformation('');
        setValue('recipientSuburb', '');
        setRecipientSuburb('');
        setValue('recipientCity', '');
        setRecipientCity('');
        setValue('recipientState', '');
        setRecipientState('');
      }
    }
  };

  const searchAddressByZipPostalCode = async (value, entity) => {
    const regex = /^\d{8}$/;
    if (value.replace('-', '').match(regex)) {
      // if (
      //   entity === 'sender' &&
      //   value.replace('-', '') === senderZipSearchedByDocument
      // ) {
      //   return;
      // }

      // if (
      //   entity === 'recipient' &&
      //   value.replace('-', '') === recipientZipSearchedByDocument
      // ) {
      //   return;
      // }

      try {
        const data = await getAddressByZipPostalCode({
          zipPostalCode: value.replace('-', '')
        });

        if (data) {
          const clear = [];

          if (data.streetAddress) {
            setValue(
              `${entity}StreetAddress`,
              data.streetAddress.toUpperCase()
            );
            clear.push(`${entity}StreetAddress`);
            if (entity === 'sender') {
              setDisableSenderStreetAddress(true);
            } else {
              setRecipientStreetAddress(data.streetAddress.toUpperCase());
              setDisableRecipientStreetAddress(true);
            }
          } else {
            setValue(`${entity}StreetAddress`, '');
            if (entity === 'sender') {
              setDisableSenderStreetAddress(false);
            } else {
              setRecipientStreetAddress('');
              setDisableRecipientStreetAddress(false);
            }
          }

          if (data.suburb) {
            setValue(`${entity}Suburb`, data.suburb.toUpperCase());
            clear.push(`${entity}Suburb`);
            if (entity === 'sender') {
              setDisableSenderSuburb(true);
            } else {
              setRecipientSuburb(data.suburb.toUpperCase());
              setDisableRecipientSuburb(true);
            }
          } else {
            setValue(`${entity}Suburb`, '');
            if (entity === 'sender') {
              setDisableSenderSuburb(false);
            } else {
              setRecipientSuburb('');
              setDisableRecipientSuburb(false);
            }
          }

          if (data.city) {
            setValue(`${entity}City`, data.city.toUpperCase());
            clear.push(`${entity}City`);
            if (entity === 'recipient') {
              setRecipientCity(data.city.toUpperCase());
            }
          } else {
            setValue(`${entity}City`, '');
            if (entity === 'recipient') {
              setRecipientCity('');
            }
          }

          if (data.state) {
            setValue(`${entity}State`, data.state.toUpperCase());
            clear.push(`${entity}State`);
            if (entity === 'recipient') {
              setRecipientState(data.state.toUpperCase());
            }
          } else {
            setValue(`${entity}State`, '');
            if (entity === 'recipient') {
              setRecipientState('');
            }
          }

          setValue(`${entity}StreetAddressNumber`, '');
          setRecipientStreetAddressNumber('');
          setValue(`${entity}AdditionalInformation`, '');
          setRecipientAdditionalInformation('');

          clearErrors(clear);
        } else {
          setValue(`${entity}StreetAddress`, '');
          setValue(`${entity}StreetAddressNumber`, '');
          setValue(`${entity}AdditionalInformation`, '');
          setValue(`${entity}Suburb`, '');
          setValue(`${entity}City`, '');
          setValue(`${entity}State`, '');

          if (entity === 'sender') {
            setDisableSenderStreetAddress(false);
            setDisableSenderSuburb(true);
          } else {
            setRecipientStreetAddress('');
            setRecipientStreetAddressNumber('');
            setRecipientAdditionalInformation('');
            setRecipientSuburb('');
            setRecipientCity('');
            setRecipientState('');
            setDisableRecipientStreetAddress(false);
            setDisableRecipientSuburb(false);
          }

          toast(
            <Toast
              title="Atenção!"
              content="O CEP informado não foi localizado."
              type="error"
            />,
            options
          );
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    } else {
      setValue(`${entity}StreetAddress`, '');
      setValue(`${entity}StreetAddressNumber`, '');
      setValue(`${entity}AdditionalInformation`, '');
      setValue(`${entity}Suburb`, '');
      setValue(`${entity}City`, '');
      setValue(`${entity}State`, '');

      if (entity === 'sender') {
        setDisableSenderStreetAddress(false);
        setDisableSenderSuburb(true);
      } else {
        setRecipientStreetAddress('');
        setRecipientStreetAddressNumber('');
        setRecipientAdditionalInformation('');
        setRecipientSuburb('');
        setRecipientCity('');
        setRecipientState('');
        setDisableRecipientStreetAddress(false);
        setDisableRecipientSuburb(false);
      }
    }
  };

  const formatInput = (value) => {
    value += '';

    if (value.length === 1) {
      value = `0,0${value}`;
    }

    value = value.replace(/[\D]+/g, '').replace(/([0-9]{2})$/g, ',$1');

    if (value.length > 6) {
      value = value.replace(/([0-9]{3}),([0-9]{2}$)/g, '.$1,$2');
    }

    if (value.charAt(0) === '0' && value.charAt(2) === ',') {
      value = value.substring(1);
    } else if (value.charAt(0) === ',') {
      value = `0${value}`;
    }

    return value === 'NaN' ? '' : value;
  };

  const calculateTotalValue = (value, id) => {
    const commodityItem = commodityList.find(
      (commodity) => commodity.id === id
    );

    value = String(
      value.replaceAll('.', '').replace(',', '.') * commodityItem.quantity
    ).replace('.', ',');

    return value;
  };

  const formatNumber = (n) => {
    // format number 1234567 to 1.234.567
    return n.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };

  const formatCurrency = ({ value, input, id, blur }) => {
    if (input === 'total') {
      value = value.toString();
    }

    if (value === '') {
      // eslint-disable-next-line no-use-before-define
      input === 'unity' && handleSetCommodityUnityValue(value, id, blur);
      // eslint-disable-next-line no-use-before-define
      input === 'total' && handleSetCommodityTotalValue(value, id, blur);
      return;
    }

    if (value === ',') {
      // eslint-disable-next-line no-use-before-define
      input === 'unity' && handleSetCommodityUnityValue('0,', id, blur);
      // eslint-disable-next-line no-use-before-define
      input === 'total' && handleSetCommodityTotalValue('0,', id, blur);
      return;
    }

    // check for decimal
    if (value.indexOf(',') >= 0) {
      // get position of first decimal
      // this prevents multiple decimals from
      // being entered
      const decimal_pos = value.indexOf(',');

      // split number by decimal point
      let left_side = value.substring(0, decimal_pos);
      let right_side = value.substring(decimal_pos);

      // add commas to left side of number
      left_side = formatNumber(left_side);

      // validate right side
      right_side = formatNumber(right_side);

      // On blur make sure 2 numbers after decimal
      if (blur) {
        right_side += '00';
      }

      // Limit decimal to only 2 digits
      right_side = right_side.substring(0, 2);

      // join number by ,
      value = `${left_side},${right_side}`;
    } else {
      // no decimal entered
      // add commas to number
      // remove all non-digits
      value = formatNumber(value);
      value = `${value}`;

      // final formatting
      if (blur) {
        value += ',00';
      }
    }

    // eslint-disable-next-line no-use-before-define
    input === 'unity' && handleSetCommodityUnityValue(value, id, blur);
    // eslint-disable-next-line no-use-before-define
    input === 'total' && handleSetCommodityTotalValue(value, id, blur);

    if (input === 'unity') {
      return calculateTotalValue(value, id);
    }
  };

  const handleAddCommodity = () => {
    const newCommodityList = [...commodityList];

    newCommodityList.push({
      id: uuid(),
      description: '',
      quantity: '',
      weight: '',
      unityValue: '',
      totalValue: '',
      observation: ''
    });

    setCommodityList(newCommodityList);
  };

  const handleRemoveCommodity = () => {
    if (commodityList.length <= 1) {
      return;
    }

    const newCommodityList = [...commodityList.slice(0, -1)];

    setCommodityList(newCommodityList);
  };

  // const handleSetCommodityDescription = (description, id, blur) => {
  //   const indexFile = commodityList.findIndex(
  //     (commodity) => commodity.id === id
  //   );

  //   const newCommodityList = [...commodityList];

  //   newCommodityList[indexFile].description = description.toUpperCase();

  //   if (!blur) {
  //     newCommodityList[indexFile].hasDescriptionError = false;
  //   } else if (blur && !description) {
  //     newCommodityList[indexFile].hasDescriptionError = true;
  //   }

  //   setCommodityList(newCommodityList);
  // };

  // const handleSetCommodityObservation = (observation, id) => {
  //   const indexFile = commodityList.findIndex(
  //     (commodity) => commodity.id === id
  //   );

  //   const newCommodityList = [...commodityList];

  //   newCommodityList[indexFile].observation = observation.toUpperCase();

  //   setCommodityList(newCommodityList);
  // };

  const handleSetCommodityQuantity = (quantity, id, blur) => {
    const indexFile = commodityList.findIndex(
      (commodity) => commodity.id === id
    );

    const newCommodityList = [...commodityList];

    newCommodityList[indexFile].quantity = quantity;

    if (!blur) {
      newCommodityList[indexFile].hasQuantityError = false;
    } else if (blur && !quantity) {
      newCommodityList[indexFile].hasQuantityError = true;
    }

    setCommodityList(newCommodityList);

    if (newCommodityList[indexFile].unityValue) {
      const total = calculateTotalValue(
        newCommodityList[indexFile].unityValue,
        id
      );

      formatCurrency({
        value: total,
        input: 'total',
        id,
        blur: true
      });
    }
  };

  const handleSetCommodityWeight = (weight, id, blur) => {
    const indexFile = commodityList.findIndex(
      (commodity) => commodity.id === id
    );

    const newCommodityList = [...commodityList];

    newCommodityList[indexFile].weight = weight;

    if (!blur) {
      newCommodityList[indexFile].hasWeightError = false;
    } else if (blur && !weight) {
      newCommodityList[indexFile].hasWeightError = true;
    }

    setCommodityList(newCommodityList);
  };

  const handleSetCommodityUnityValue = (unityValue, id, blur) => {
    const indexFile = commodityList.findIndex(
      (commodity) => commodity.id === id
    );

    const newCommodityList = [...commodityList];

    newCommodityList[indexFile].unityValue = unityValue;

    if (!blur) {
      newCommodityList[indexFile].hasUnityValueError = false;
    } else if (blur && !unityValue) {
      newCommodityList[indexFile].hasUnityValueError = true;
    }

    setCommodityList(newCommodityList);
  };

  const handleSetCommodityTotalValue = (totalValue, id) => {
    const indexFile = commodityList.findIndex(
      (commodity) => commodity.id === id
    );

    const newCommodityList = [...commodityList];

    newCommodityList[indexFile].totalValue = totalValue;

    setCommodityList(newCommodityList);
  };

  useEffect(() => {
    const subscription = watch((value) => {
      if (
        !value?.senderDocument ||
        !value?.senderName ||
        !value?.senderZipPostalCode ||
        !value?.senderStreetAddress ||
        !value?.senderStreetAddressNumber ||
        !value?.senderSuburb ||
        !value?.senderCity ||
        !value?.senderState ||
        !value?.recipientDocument ||
        !value?.recipientName ||
        !value?.recipientZipPostalCode ||
        !value?.recipientStreetAddress ||
        !value?.recipientStreetAddressNumber ||
        !value?.recipientSuburb ||
        !value?.recipientCity ||
        !value?.recipientState
      ) {
        setHasMissingAddressValue(true);
      } else {
        setHasMissingAddressValue(false);
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    let hasMissingCommodityInfo = false;

    commodityList?.forEach((value) => {
      if (
        // !value?.description ||
        !value?.quantity ||
        !value?.weight ||
        !value?.unityValue
      ) {
        hasMissingCommodityInfo = true;
      }
    });

    if (hasMissingCommodityInfo) {
      setHasMissingCommodityValue(true);
    } else {
      setHasMissingCommodityValue(false);
    }
  }, [JSON.stringify(commodityList)]);

  useEffect(() => {
    const cpfCnpjOptions = {
      onKeyPress(cpf, _ev, _el, op) {
        const masks = ['000.000.000-000', '00.000.000/0000-00'];
        $('#senderDocument').mask(cpf.length > 14 ? masks[1] : masks[0], op);
      }
    };

    $('#senderDocument').length > 11
      ? $('#senderDocument').mask('00.000.000/0000-00', cpfCnpjOptions)
      : $('#senderDocument').mask('000.000.000-00#', cpfCnpjOptions);
  }, [senderDocument]);

  useEffect(() => {
    $('#senderZipPostalCode').mask('00000-000');
  }, [senderZipPostalCode]);

  useEffect(() => {
    const cpfCnpjOptions = {
      onKeyPress(cpf, _ev, _el, op) {
        const masks = ['000.000.000-000', '00.000.000/0000-00'];
        $('#recipientDocument').mask(cpf.length > 14 ? masks[1] : masks[0], op);
      }
    };

    $('#recipientDocument').length > 11
      ? $('#recipientDocument').mask('00.000.000/0000-00', cpfCnpjOptions)
      : $('#recipientDocument').mask('000.000.000-00#', cpfCnpjOptions);
  }, [recipientDocument]);

  useEffect(() => {
    $('#recipientZipPostalCode').mask('00000-000');
  }, [recipientZipPostalCode]);

  useEffect(() => {
    const {
      // eslint-disable-next-line no-shadow
      document: senderDocument,
      name: senderName,
      address: {
        // eslint-disable-next-line no-shadow
        zipPostalCode: senderZipPostalCode,
        streetAddress: senderStreetAddress,
        streetAddressNumber: senderStreetAddressNumber,
        additionalInformation: senderAdditionalInformation,
        suburb: senderSuburb,
        city: senderCity,
        state: senderState
      }
    } = collectSenderData;

    senderDocument && setValue('senderDocument', senderDocument);
    senderName && setValue('senderName', senderName);
    senderZipPostalCode && setValue('senderZipPostalCode', senderZipPostalCode);
    senderStreetAddress && setValue('senderStreetAddress', senderStreetAddress);
    senderStreetAddressNumber &&
      setValue('senderStreetAddressNumber', senderStreetAddressNumber);
    senderAdditionalInformation &&
      setValue('senderAdditionalInformation', senderAdditionalInformation);
    senderSuburb && setValue('senderSuburb', senderSuburb);
    senderCity && setValue('senderCity', senderCity);
    senderState && setValue('senderState', senderState);

    // const {
    //   // eslint-disable-next-line no-shadow
    //   document: recipientDocument,
    //   // eslint-disable-next-line no-shadow
    //   name: recipientName,
    //   address: {

    //     zipPostalCode: recipientZipPostalCode ? recipientZipPostalCode : '',
    //     // eslint-disable-next-line no-shadow
    //     streetAddress: recipientStreetAddress,
    //     // eslint-disable-next-line no-shadow
    //     streetAddressNumber: recipientStreetAddressNumber,
    //     // eslint-disable-next-line no-shadow
    //     additionalInformation: recipientAdditionalInformation,
    //     // eslint-disable-next-line no-shadow
    //     suburb: recipientSuburb,
    //     // eslint-disable-next-line no-shadow
    //     city: recipientCity,
    //     // eslint-disable-next-line no-shadow
    //     state: recipientState
    //   }
    // } = collectRecipientData;

    recipientDocument && setValue('recipientDocument', recipientDocument);
    recipientDocument && setRecipientDocument(recipientDocument);
    recipientName && setValue('recipientName', recipientName);
    recipientName && setRecipientName(recipientName);
    recipientZipPostalCode &&
      setValue('recipientZipPostalCode', recipientZipPostalCode);
    recipientZipPostalCode && setRecipientZipPostalCode(recipientZipPostalCode);
    recipientStreetAddress &&
      setValue('recipientStreetAddress', recipientStreetAddress);
    recipientStreetAddress && setRecipientStreetAddress(recipientStreetAddress);
    recipientStreetAddressNumber &&
      setValue('recipientStreetAddressNumber', recipientStreetAddressNumber);
    recipientStreetAddressNumber &&
      setRecipientStreetAddressNumber(recipientStreetAddressNumber);
    recipientAdditionalInformation &&
      setValue(
        'recipientAdditionalInformation',
        recipientAdditionalInformation
      );
    recipientAdditionalInformation &&
      setRecipientAdditionalInformation(recipientAdditionalInformation);
    recipientSuburb && setValue('recipientSuburb', recipientSuburb);
    recipientSuburb && setRecipientSuburb(recipientSuburb);
    recipientCity && setValue('recipientCity', recipientCity);
    recipientCity && setRecipientCity(recipientCity);
    recipientState && setValue('recipientState', recipientState);
    recipientState && setRecipientState(recipientState);

    // const materialTypeDescription = materialTypeList.find(
    //   (materialType) =>
    //     `${materialType.branchMaterialId}` === `${collectLoadData.material}`
    // );

    // handleSetCommodityDescription(
    //   materialTypeDescription?.materialDescription,
    //   commodityList[0]?.id,
    //   false
    // );
    // handleSetCommodityObservation(
    //   collectLoadData.MaterialDetail,
    //   commodityList[0]?.id
    // );
    handleSetCommodityQuantity(
      collectLoadData.loadVolume,
      commodityList[0]?.id,
      false
    );
    handleSetCommodityWeight(
      collectLoadData.loadWeight,
      commodityList[0]?.id,
      false
    );
  }, []);

  return (
    <Modal preventClose>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 16,
            maxHeight: '86vh',
            overflow: 'auto'
          }}
        >
          <ModalTitle>FORMULÁRIO DE DECLARAÇÃO</ModalTitle>

          <Stack spacing={2} style={{ marginTop: '8px' }}>
            <strong>Remetente:</strong>

            <Stack direction={maxMD ? 'column' : 'row'} spacing={2}>
              <Controller
                name="senderDocument"
                control={control}
                defaultValue=""
                render={({ field }) => {
                  return (
                    <TextField
                      label="CNPJ / CPF *"
                      id="senderDocument"
                      data-testid="senderDocumentInput"
                      style={{ minWidth: 240 }}
                      {...field}
                      disabled
                      onChange={(e) => {
                        setSenderDocument(e.target.value);
                        field.onChange(e.target.value);
                      }}
                      onBlur={(e) => {
                        getDocumentInfo(e.target.value, 'sender');
                        setSenderDocument(e.target.value);
                        field.onChange(e.target.value);
                      }}
                      error={!!errors.senderDocument}
                      helperText={errors.senderDocument?.message}
                    />
                  );
                }}
              />

              <Controller
                name="senderName"
                defaultValue=""
                control={control}
                render={({ field }) => (
                  <TextField
                    label="Razão Social/Nome *"
                    data-testid="senderNameInput"
                    style={{ width: '100%' }}
                    {...field}
                    disabled
                    onChange={(e) => {
                      field.onChange(e.target.value.toUpperCase());
                    }}
                    onBlur={(e) => {
                      field.onBlur(
                        field.onChange(e.target.value.toUpperCase())
                      );
                    }}
                    inputProps={{ maxLength: 256 }}
                    error={!!errors.senderName}
                    helperText={errors.senderName?.message}
                  />
                )}
              />
            </Stack>

            <Stack direction={maxSM ? 'column' : 'row'} spacing={2}>
              <Controller
                name="senderZipPostalCode"
                defaultValue=""
                control={control}
                render={({ field }) => (
                  <TextField
                    label="CEP *"
                    id="senderZipPostalCode"
                    data-testid="senderZipPostalCodeInput"
                    style={{ width: !maxMD && 240 }}
                    {...field}
                    disabled
                    onChange={(e) => {
                      setSenderZipPostalCode(e.target.value);
                      field.onChange(e.target.value);
                    }}
                    onBlur={(e) => {
                      const { value } = e.target;
                      searchAddressByZipPostalCode(value, 'sender');

                      setSenderZipPostalCode(value);
                      field.onBlur(field.onChange(value));
                    }}
                    error={!!errors.senderZipPostalCode}
                    helperText={errors.senderZipPostalCode?.message}
                  />
                )}
              />

              <Controller
                name="senderStreetAddress"
                defaultValue=""
                control={control}
                render={({ field }) => (
                  <TextField
                    label="Endereço *"
                    data-testid="senderStreetAddressInput"
                    style={{ width: maxMD && '100%', flex: !maxMD && '1' }}
                    {...field}
                    disabled
                    onChange={(e) => {
                      field.onChange(e.target.value.toUpperCase());
                    }}
                    onBlur={(e) => {
                      field.onBlur(
                        field.onChange(e.target.value.toUpperCase())
                      );
                    }}
                    inputProps={{ maxLength: 256 }}
                    error={!!errors.senderStreetAddress}
                    helperText={errors.senderStreetAddress?.message}
                  />
                )}
              />

              <Controller
                name="senderStreetAddressNumber"
                defaultValue=""
                control={control}
                render={({ field }) => (
                  <TextField
                    label="Número *"
                    data-testid="senderStreetAddressNumberInput"
                    style={{ width: maxSM ? '100%' : 96, minWidth: 96 }}
                    {...field}
                    disabled
                    onChange={(e) => {
                      const regex = /^[aA-zZ0-9\s]+$/;
                      if (
                        !e.target.value.match(regex) &&
                        e.target.value !== ''
                      ) {
                        return;
                      }

                      field.onChange(e.target.value);
                    }}
                    onBlur={(e) => field.onBlur(field.onChange(e.target.value))}
                    inputProps={{ maxLength: 50 }}
                    error={!!errors.senderStreetAddressNumber}
                    helperText={errors.senderStreetAddressNumber?.message}
                  />
                )}
              />
            </Stack>

            <Stack direction={maxMD ? 'column' : 'row'} spacing={2}>
              <Stack
                direction={maxSM ? 'column' : 'row'}
                spacing={2}
                style={{ width: maxMD ? '100%' : '55%' }}
              >
                <Controller
                  name="senderAdditionalInformation"
                  defaultValue=""
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="Complemento"
                      data-testid="senderAdditionalInformationInput"
                      style={{ width: !maxMD && 240 }}
                      fullWidth={maxMD}
                      {...field}
                      disabled
                      onChange={(e) => {
                        field.onChange(e.target.value.toUpperCase());
                      }}
                      onBlur={(e) => {
                        field.onBlur(
                          field.onChange(e.target.value.toUpperCase())
                        );
                      }}
                      inputProps={{ maxLength: 256 }}
                      error={!!errors.senderAdditionalInformation}
                      helperText={errors.senderAdditionalInformation?.message}
                    />
                  )}
                />

                <Controller
                  name="senderSuburb"
                  defaultValue=""
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="Bairro *"
                      data-testid="senderSuburbInput"
                      style={{ flex: !maxMD && '1' }}
                      fullWidth={maxMD}
                      {...field}
                      disabled
                      onChange={(e) => {
                        field.onChange(e.target.value.toUpperCase());
                      }}
                      onBlur={(e) => {
                        field.onBlur(
                          field.onChange(e.target.value.toUpperCase())
                        );
                      }}
                      inputProps={{ maxLength: 50 }}
                      error={!!errors.senderSuburb}
                      helperText={errors.senderSuburb?.message}
                    />
                  )}
                />
              </Stack>

              <Stack
                direction="row"
                spacing={2}
                style={{ width: maxMD ? '100%' : '45%' }}
              >
                <Controller
                  name="senderCity"
                  defaultValue=""
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="Cidade *"
                      data-testid="senderCityInput"
                      style={{ flex: !maxMD && '1' }}
                      fullWidth={maxMD}
                      {...field}
                      disabled
                      onChange={(e) => {
                        field.onChange(e.target.value.toUpperCase());
                      }}
                      onBlur={(e) => {
                        field.onBlur(
                          field.onChange(e.target.value.toUpperCase())
                        );
                      }}
                      inputProps={{ maxLength: 50 }}
                      error={!!errors.senderCity}
                      helperText={errors.senderCity?.message}
                    />
                  )}
                />

                <Controller
                  name="senderState"
                  defaultValue=""
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="UF *"
                      data-testid="senderStateInput"
                      style={{ width: 96, minWidth: 96 }}
                      {...field}
                      disabled
                      onChange={(e) => {
                        const regex = /^[aA-zZ\s]+$/;
                        if (
                          !e.target.value.match(regex) &&
                          e.target.value !== ''
                        ) {
                          return;
                        }
                        field.onChange(e.target.value.toUpperCase());
                      }}
                      onBlur={(e) => {
                        field.onBlur(
                          field.onChange(e.target.value.toUpperCase())
                        );
                      }}
                      inputProps={{ maxLength: 2 }}
                      error={!!errors.senderState}
                      helperText={errors.senderState?.message}
                    />
                  )}
                />
              </Stack>
            </Stack>
          </Stack>

          <Stack spacing={2} style={{ marginTop: '8px' }}>
            <strong>Destinatário:</strong>

            <Stack direction={maxMD ? 'column' : 'row'} spacing={2}>
              <Controller
                name="recipientDocument"
                control={control}
                defaultValue=""
                render={({ field }) => {
                  return (
                    <TextField
                      label="CNPJ / CPF *"
                      id="recipientDocument"
                      data-testid="recipientDocumentInput"
                      style={{ minWidth: 240 }}
                      {...field}
                      value={(field.value = recipientDocument)}
                      onChange={(e) => {
                        setIsToValidateRecipientDocument(true);
                        setRecipientDocument(e.target.value);
                        field.onChange(e.target.value);
                      }}
                      onBlur={(e) => {
                        getDocumentInfo(e.target.value, 'recipient');
                        setRecipientDocument(e.target.value);
                        field.onBlur(field.onChange(e.target.value));
                      }}
                      error={!!errors.recipientDocument}
                      helperText={errors.recipientDocument?.message}
                    />
                  );
                }}
              />

              <Controller
                name="recipientName"
                defaultValue=""
                control={control}
                render={({ field }) => (
                  <TextField
                    label="Razão Social/Nome *"
                    data-testid="recipientNameInput"
                    style={{ width: '100%' }}
                    {...field}
                    value={(field.value = recipientName)}
                    disabled={disableRecipientName}
                    onChange={(e) => {
                      setRecipientName(e.target.value.toUpperCase());
                      field.onChange(e.target.value.toUpperCase());
                    }}
                    onBlur={(e) => {
                      setRecipientName(e.target.value.toUpperCase());
                      field.onBlur(
                        field.onChange(e.target.value.toUpperCase())
                      );
                    }}
                    error={!!errors.recipientName}
                    helperText={errors.recipientName?.message}
                  />
                )}
              />
            </Stack>

            <Stack direction={maxSM ? 'column' : 'row'} spacing={2}>
              <Controller
                name="recipientZipPostalCode"
                defaultValue=""
                control={control}
                render={({ field }) => (
                  <TextField
                    label="CEP *"
                    id="recipientZipPostalCode"
                    data-testid="recipientZipPostalCodeInput"
                    style={{ width: !maxMD && 240 }}
                    {...field}
                    value={(field.value = recipientZipPostalCode)}
                    onChange={(e) => {
                      setRecipientZipPostalCode(e.target.value);
                      field.onChange(e.target.value);
                    }}
                    onBlur={(e) => {
                      const { value } = e.target;
                      searchAddressByZipPostalCode(value, 'recipient');

                      setRecipientZipPostalCode(e.target.value);
                      field.onBlur(field.onChange(value));
                    }}
                    error={!!errors.recipientZipPostalCode}
                    helperText={errors.recipientZipPostalCode?.message}
                  />
                )}
              />

              <Controller
                name="recipientStreetAddress"
                defaultValue=""
                control={control}
                render={({ field }) => (
                  <TextField
                    label="Endereço *"
                    data-testid="recipientStreetAddressInput"
                    style={{ width: maxMD && '100%', flex: !maxMD && '1' }}
                    {...field}
                    value={(field.value = recipientStreetAddress)}
                    disabled={!!disableRecipientStreetAddress}
                    onChange={(e) => {
                      setRecipientStreetAddress(e.target.value.toUpperCase());
                      field.onChange(e.target.value.toUpperCase());
                    }}
                    onBlur={(e) => {
                      setRecipientStreetAddress(e.target.value.toUpperCase());
                      field.onBlur(
                        field.onChange(e.target.value.toUpperCase())
                      );
                    }}
                    inputProps={{ maxLength: 256 }}
                    error={!!errors.recipientStreetAddress}
                    helperText={errors.recipientStreetAddress?.message}
                  />
                )}
              />

              <Controller
                name="recipientStreetAddressNumber"
                defaultValue=""
                control={control}
                render={({ field }) => (
                  <TextField
                    label="Número *"
                    data-testid="recipientStreetAddressNumberInput"
                    style={{ width: maxSM ? '100%' : 96, minWidth: 96 }}
                    {...field}
                    value={(field.value = recipientStreetAddressNumber)}
                    onChange={(e) => {
                      const regex = /^[aA-zZ0-9\s]+$/;
                      if (
                        !e.target.value.match(regex) &&
                        e.target.value !== ''
                      ) {
                        return;
                      }

                      setRecipientStreetAddressNumber(e.target.value);
                      field.onChange(e.target.value);
                    }}
                    onBlur={(e) => {
                      setRecipientStreetAddressNumber(e.target.value);
                      field.onBlur(field.onChange(e.target.value));
                    }}
                    inputProps={{ maxLength: 50 }}
                    error={!!errors.recipientStreetAddressNumber}
                    helperText={errors.recipientStreetAddressNumber?.message}
                  />
                )}
              />
            </Stack>

            <Stack direction={maxMD ? 'column' : 'row'} spacing={2}>
              <Stack
                direction={maxSM ? 'column' : 'row'}
                spacing={2}
                style={{ width: maxMD ? '100%' : '55%' }}
              >
                <Controller
                  name="recipientAdditionalInformation"
                  defaultValue=""
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="Complemento"
                      data-testid="recipientAdditionalInformationInput"
                      style={{ width: !maxMD && 240 }}
                      fullWidth={maxMD}
                      {...field}
                      value={(field.value = recipientAdditionalInformation)}
                      onChange={(e) => {
                        setRecipientAdditionalInformation(
                          e.target.value.toUpperCase()
                        );
                        field.onChange(e.target.value.toUpperCase());
                      }}
                      onBlur={(e) => {
                        setRecipientAdditionalInformation(
                          e.target.value.toUpperCase()
                        );
                        field.onBlur(
                          field.onChange(e.target.value.toUpperCase())
                        );
                      }}
                      inputProps={{ maxLength: 256 }}
                      error={!!errors.recipientAdditionalInformation}
                      helperText={
                        errors.recipientAdditionalInformation?.message
                      }
                    />
                  )}
                />

                <Controller
                  name="recipientSuburb"
                  defaultValue=""
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="Bairro *"
                      data-testid="recipientSuburbInput"
                      style={{ flex: !maxMD && '1' }}
                      fullWidth={maxMD}
                      {...field}
                      value={(field.value = recipientSuburb)}
                      disabled={!!disableRecipientSuburb}
                      onChange={(e) => {
                        setRecipientSuburb(e.target.value.toUpperCase());
                        field.onChange(e.target.value.toUpperCase());
                      }}
                      onBlur={(e) => {
                        setRecipientSuburb(e.target.value.toUpperCase());
                        field.onBlur(
                          field.onChange(e.target.value.toUpperCase())
                        );
                      }}
                      inputProps={{ maxLength: 50 }}
                      error={!!errors.recipientSuburb}
                      helperText={errors.recipientSuburb?.message}
                    />
                  )}
                />
              </Stack>

              <Stack
                direction="row"
                spacing={2}
                style={{ width: maxMD ? '100%' : '45%' }}
              >
                <Controller
                  name="recipientCity"
                  defaultValue=""
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="Cidade *"
                      data-testid="recipientCityInput"
                      style={{ flex: !maxMD && '1' }}
                      fullWidth={maxMD}
                      {...field}
                      value={(field.value = recipientCity)}
                      disabled
                      onChange={(e) => {
                        setRecipientCity(e.target.value.toUpperCase());
                        field.onChange(e.target.value.toUpperCase());
                      }}
                      onBlur={(e) => {
                        setRecipientCity(e.target.value.toUpperCase());
                        field.onBlur(
                          field.onChange(e.target.value.toUpperCase())
                        );
                      }}
                      inputProps={{ maxLength: 50 }}
                      error={!!errors.recipientCity}
                      helperText={errors.recipientCity?.message}
                    />
                  )}
                />

                <Controller
                  name="recipientState"
                  defaultValue=""
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="UF *"
                      data-testid="recipientStateInput"
                      style={{ width: 96, minWidth: 96 }}
                      {...field}
                      value={(field.value = recipientState)}
                      disabled
                      onChange={(e) => {
                        const regex = /^[aA-zZ\s]+$/;
                        if (
                          !e.target.value.match(regex) &&
                          e.target.value !== ''
                        ) {
                          return;
                        }

                        setRecipientState(e.target.value.toUpperCase());
                        field.onChange(e.target.value.toUpperCase());
                      }}
                      onBlur={(e) => {
                        setRecipientState(e.target.value.toUpperCase());
                        field.onBlur(
                          field.onChange(e.target.value.toUpperCase())
                        );
                      }}
                      inputProps={{ maxLength: 2 }}
                      error={!!errors.recipientState}
                      helperText={errors.recipientState?.message}
                    />
                  )}
                />
              </Stack>
            </Stack>
          </Stack>

          <Stack spacing={2} style={{ marginTop: '8px' }}>
            <Stack spacing={1} direction="row">
              <strong>Mercadorias:</strong>

              <button
                type="button"
                data-testid="removeCommodityButton"
                onClick={handleRemoveCommodity}
                disabled={commodityList.length <= 1}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 19,
                  height: 19,
                  borderRadius: '50%',
                  border: 'none',
                  outline: 'none',
                  backgroundColor: commodityList.length > 1 ? '#004e9a' : '#bbb'
                }}
              >
                <MdRemove size={19} style={{ color: '#fff' }} />
              </button>

              <button
                type="button"
                data-testid="addCommodityButton"
                onClick={handleAddCommodity}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 19,
                  height: 19,
                  borderRadius: '50%',
                  border: 'none',
                  outline: 'none',
                  backgroundColor: '#004e9a'
                }}
              >
                <MdAdd size={19} style={{ color: '#fff' }} />
              </button>
            </Stack>

            <Stack
              spacing={2}
              divider={<Divider orientation="horizontal" flexItem />}
            >
              {commodityList.map(
                (
                  {
                    id,
                    description,
                    quantity,
                    weight,
                    unityValue,
                    totalValue,
                    observation,
                    hasDescriptionError,
                    hasQuantityError,
                    hasWeightError,
                    hasUnityValueError
                  },
                  index
                ) => (
                  <Stack key={id} spacing={2}>
                    <p>{index + 1}° item</p>
                    {/* <Stack direction={maxMD ? 'column' : 'row'} spacing={2}>
                      <TextField
                        label="Descrição *"
                        data-testid={`description${index}Input`}
                        value={description}
                        fullWidth
                        onChange={(e) => {
                          handleSetCommodityDescription(
                            e.target.value,
                            id,
                            false
                          );
                        }}
                        onBlur={(e) => {
                          handleSetCommodityDescription(
                            e.target.value,
                            id,
                            true
                          );
                        }}
                        error={!!hasDescriptionError}
                        helperText={
                          hasDescriptionError && 'Descrição obrigatória'
                        }
                      />
                      <TextField
                        label="Observações"
                        data-testid={`observation${index}Input`}
                        value={observation}
                        fullWidth
                        onChange={(e) => {
                          handleSetCommodityObservation(e.target.value, id);
                        }}
                      />
                    </Stack> */}

                    <Stack direction={maxMD ? 'column' : 'row'} spacing={2}>
                      <Stack
                        direction="row"
                        spacing={2}
                        style={{ width: '100%' }}
                      >
                        <TextField
                          label="Quantidade *"
                          data-testid={`quantity${index}Input`}
                          value={quantity}
                          fullWidth
                          onChange={(e) => {
                            const regex = /^[0-9]+$/;
                            if (
                              !e.target.value.match(regex) &&
                              e.target.value !== ''
                            ) {
                              return;
                            }

                            handleSetCommodityQuantity(
                              e.target.value,
                              id,
                              false
                            );
                          }}
                          onBlur={(e) => {
                            handleSetCommodityQuantity(
                              e.target.value,
                              id,
                              true
                            );
                          }}
                          error={!!hasQuantityError}
                          helperText={
                            hasQuantityError && 'Quantidade obrigatória'
                          }
                        />

                        <TextField
                          label="Peso *"
                          data-testid={`weight${index}Input`}
                          value={weight}
                          fullWidth
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">kg</InputAdornment>
                            )
                          }}
                          onChange={(e) => {
                            handleSetCommodityWeight(
                              formatInput(e.target.value),
                              id,
                              false
                            );
                          }}
                          onBlur={(e) => {
                            handleSetCommodityWeight(
                              formatInput(e.target.value),
                              id,
                              true
                            );
                          }}
                          error={!!hasWeightError}
                          helperText={hasWeightError && 'Peso obrigatório'}
                        />
                      </Stack>

                      <Stack
                        direction="row"
                        spacing={2}
                        style={{ width: '100%' }}
                      >
                        <TextField
                          label="Valor unitário *"
                          data-testid={`unityValue${index}Input`}
                          value={unityValue}
                          fullWidth
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                R$
                              </InputAdornment>
                            )
                          }}
                          onChange={(e) => {
                            const total = formatCurrency({
                              value: e.target.value,
                              input: 'unity',
                              id,
                              blur: false
                            });

                            if (total) {
                              formatCurrency({
                                value: total,
                                input: 'total',
                                id,
                                blur: true
                              });
                            } else {
                              formatCurrency({
                                value: '',
                                input: 'total',
                                id,
                                blur: true
                              });
                            }
                          }}
                          onBlur={(e) => {
                            formatCurrency({
                              value: e.target.value,
                              input: 'unity',
                              id,
                              blur: true
                            });
                          }}
                          error={!!hasUnityValueError}
                          helperText={
                            hasUnityValueError && 'Valor unitário obrigatório'
                          }
                        />

                        <TextField
                          label="Valor total"
                          data-testid={`totalValue${index}Input`}
                          value={totalValue}
                          // required
                          disabled
                          fullWidth
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                R$
                              </InputAdornment>
                            )
                          }}
                          onChange={(e) => {
                            formatCurrency({
                              value: e.target.value,
                              input: 'total',
                              id,
                              blur: false
                            });
                          }}
                          onBlur={(e) => {
                            formatCurrency({
                              value: e.target.value,
                              input: 'total',
                              id,
                              blur: true
                            });
                          }}
                        />
                      </Stack>
                    </Stack>
                  </Stack>
                )
              )}
            </Stack>
          </Stack>

          <Stack
            direction="row"
            spacing={2}
            style={{ marginTop: 8, marginBottom: 4 }}
          >
            <Box
              style={{ display: 'flex', flex: 1, justifyContent: 'flex-end' }}
            >
              <Button
                type="button"
                variant="contained"
                color="secondary"
                data-testid="cancelCreateDeclarationModalButton"
                onClick={closeModal}
              >
                Cancelar
              </Button>
            </Box>

            <Box style={{ flex: 1 }}>
              <Button
                type="submit"
                data-testid="saveCreateDeclarationModalButton"
                variant="contained"
                disabled={hasMissingAddressValue || hasMissingCommodityValue}
              >
                Salvar
              </Button>
            </Box>
          </Stack>
        </Box>
      </form>
    </Modal>
  );
};
